import { OffScriptStats } from './OffScriptStats'
import { OffScriptTaxonomy } from './OffScriptTaxonomy'
import { OffScriptEscalation } from './OffScriptEscalation'

/**
 * The interactive recap for "We Red-Teamed Our Own AI Agent and Found 14
 * Real Bugs", mounted by ArticlePage's `afterContent` slot (wired in
 * content-routes.tsx) rather than from inside the post's .mdx body: the
 * .mdx must stay clean, warning-free markdown for the AI-crawler export
 * (tests/blog-markdown.test.ts fails the build on any stripped JSX).
 * Placed after the full written account on purpose: the taxonomy and the
 * six-turn escalation both use terms (Crescendo, "Exhibit B") a reader
 * needs the story above to make sense of first, this is the
 * explore-it-yourself version second.
 */
export function OffScriptInteractive() {
  return (
    <div className="rounded-3xl border border-ink-100 bg-paper-soft/30 p-6 md:p-8">
      <div className="font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-ink-400">
        Explore it yourself
      </div>

      <OffScriptStats />

      <p className="mt-6 text-[14.5px] leading-[1.55] text-ink-500">
        We test other people's agents for a living, so we red-teamed our own too: Langy, after a real bug slipped past 50+ passing tests. Here's the three-layer method from the story above, and the six-turn escalation that took four rounds to close, both explorable below.
      </p>

      <div className="mt-8">
        <div className="mb-1 text-[13px] font-semibold text-ink-700">Three layers, each catching what the last one couldn't</div>
        <OffScriptTaxonomy />
      </div>

      <div className="mt-8">
        <div className="mb-1 text-[13px] font-semibold text-ink-700">Exhibit B: step through the escalation</div>
        <OffScriptEscalation />
      </div>
    </div>
  )
}
